/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import I18n from '../../components/Translate/I18n';
import GridItem from '../../components/Grid/GridItem';
import ActionButton from '../../components/Buttons/CustomTextButton';
import AlertInfo from '../../components/Info/AlertInfo';
import CustomInputExt from '../../components/CustomInput/CustomInputExt';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';

type ReloadAccountType = {
    classes?: any;
    product: SimCardInterface;
    itemLoader?: ItemLoaders;
    refreshPage?: () => void;
};

export const ReloadAccount: FunctionComponent<ReloadAccountType> = ({ classes, product, itemLoader, refreshPage }) => {
    const dispatch = useDispatch();
    const [reloadValue, setReloadValue] = useState<number | null>(null);
    const [reloadAccount, setReloadAccount] = useState(false);
    const [alertInfo, setAlertInfo] = useState<React.ReactElement | null>(null);

    const callReloadAccount = (): void => {
        const params = { id: product.id, reloadAccountEvent: true, reloadAccountAmount: reloadValue };
        setReloadValue(null);
        setAlertInfo(null);
        if (!itemLoader) {
            itemLoader = new ItemLoaders(dispatch);
        }
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_card_balances/' + product.id),
            'product_reload_account',
            params,
            (): void => {
                if (refreshPage) {
                    refreshPage();
                }
            },
            { propagateDataToCallback: true }
        );
    };
    const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setReloadValue(parseFloat(e.target.value));
    };

    const setAlertInfoBox = (): void => {
        setAlertInfo(
            <AlertInfo
                onConfirm={callReloadAccount}
                onCancel={(): void => {
                    setAlertInfo(null);
                }}
                confirmBtnText={'simcard:f.save_change'}
                cancelBtnText={'general:common.cancel'}
                content="simcard:r.confirm_reload_account"
                valueObject={{ amount: reloadValue }}
                show={true}
                classes={classes}
            />
        );
    };

    useEffect((): void => {
        if (reloadValue && reloadValue !== 0) {
            setReloadAccount(true);
        } else {
            setReloadAccount(false);
        }
    }, [reloadValue]);

    return (
        <GridContainer>
            <GridItem xs={12}>
                <I18n trans="simcard:r.reload_account" />
            </GridItem>
            <GridItem xs={12}>
                <CustomInputExt
                    onChange={onChange}
                    name="reloadValue"
                    onClick={(): void => {}}
                    value={reloadValue}
                    labelText="simcard:r.reload_amount"
                />
            </GridItem>
            {reloadAccount && (
                <GridItem xs={12}>
                    <ActionButton size="sm" callback={setAlertInfoBox} callbackParam={{}} label="simcard:r.do_reload_account" />
                </GridItem>
            )}
            {alertInfo}
        </GridContainer>
    );
};
